export function daysSince(date: Date | string, ref?: Date): number {
  const refDate = ref || new Date();
  return (refDate.getTime() - new Date(date).getTime()) / (1000 * 60 * 60 * 24);
}
